import { Container } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Outlet, useNavigate } from "react-router-dom";
import dayjs from "./utils/dayjs.ts";
import useLocale from "./utils/useLocale.ts";
import NavBar from "./layout/NavBar/NavBar.tsx";
import Footer from "./layout/Footer/Footer.tsx";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./NavigationClient.ts";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0A175A",
    },
    background: {
      default: "#F7F7F7",
    },
  },
  typography: {
    fontFamily: [
      "Fira Sans",
      "Roboto",
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
  },
});

interface AppProps {
  pca: IPublicClientApplication;
}

function App({ pca }: AppProps) {
  const { locale } = useLocale();
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  return (
    <LocalizationProvider
      dateLibInstance={dayjs}
      dateAdapter={AdapterDayjs}
      adapterLocale={locale}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <NavBar />
        <Container>
          <Outlet />
        </Container>
        <Footer />
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
